import React from "react";
import { Card } from "@mui/material";
import { styled } from "@mui/material/styles";

const GridCardContent = styled(Card)(() => ({
  display: "flex",
  alignItems: "center",
  marginBottom: "10px",
}));

export default GridCardContent;
